import React from 'react';
import { Layout } from 'antd';
import Sidebar from 'components/Sidebar/Sidebar';
import { RouteRedirect } from 'react-structure-admin';
import 'components/IconLibrary';
import InsideHeader from 'components/Topbar/InsideHeader';
import useSubscription from 'core/hooks/useSubscription';
import UploadRegistrationStatementModal from 'pages/shared/UploadRegistrationStatementModal';
import useAuth from 'core/hooks/useAuth';
import { Routes } from 'components/routes';

const { Content } = Layout;

const AppContainer = (props) => {
  const { match, routes, roles, basePath } = props;
  const { isAuthenticated, isAdmin, isMultiTenant, user, tenantId } = useAuth();
  const { isActivated, hasLicense } = useSubscription();

  const onBeforeRouteRender = ({ route }) => {
    if (isAuthenticated && isAdmin() && !tenantId) {
      return <RouteRedirect to="/a" />;
    }

    if (isAuthenticated && isMultiTenant && !tenantId) {
      return <RouteRedirect to="/accounts-chooser" />;
    }

    if (!isAuthenticated) {
      return <RouteRedirect to="/signout" />;
    }

    if (
      !isActivated &&
      hasLicense &&
      route?.path !== '/expired-license' &&
      route?.path !== '/subscriptions'
    ) {
      return <RouteRedirect to="/app/expired-license" />;
    }

    if (
      !isActivated &&
      route?.path !== '/subscriptions' &&
      route?.path !== '/expired-license'
    ) {
      const allowedRoutes =
        !isAdmin() && user.hasTreatmentInvite
          ? ['/patients', '/:id/history']
          : [];

      if (!allowedRoutes.some((c) => route.path.startsWith(c))) {
        return <RouteRedirect to="/app/subscriptions" />;
      }
    }

    return null;
  };

  return (
    <Layout className="gx-app-layout">
      <UploadRegistrationStatementModal />
      <Sidebar routes={routes} match={match} />
      <Layout>
        <InsideHeader routes={routes} match={match} />
        <Content
          id="main-container"
          className="gx-layout-content gx-container-wrap"
        >
          <div className="gx-main-content-wrapper">
            <Routes
              match={match}
              routes={routes}
              roles={roles}
              basePath={basePath}
              onBeforeRouteRender={onBeforeRouteRender}
              isContainer
            />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default AppContainer;
